var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3681 0.378906C18.0782 0.378906 13.8846 1.65102 10.3176 4.03439C6.75063 6.41776 3.97052 9.80533 2.32883 13.7687C0.687133 17.7321 0.257591 22.0933 1.09452 26.3009C1.93145 30.5084 3.99725 34.3732 7.03071 37.4067C10.0642 40.4401 13.929 42.5059 18.1365 43.3429C22.3441 44.1798 26.7053 43.7503 30.6687 42.1086C34.6321 40.4669 38.0196 37.6868 40.403 34.1198C42.7864 30.5528 44.0585 26.3592 44.0585 22.0693C44.0585 16.3166 41.7733 10.7996 37.7055 6.73187C33.6378 2.66413 28.1208 0.378906 22.3681 0.378906ZM31.5648 29.2994L29.5982 31.266L22.3681 24.1082L15.2103 31.266L13.1714 29.2994L20.3292 22.0693L13.1714 14.9115L15.2103 12.8726L22.3681 20.0304L29.5982 12.8726L31.6371 14.9115L24.407 22.0693L31.5648 29.2994Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.fdb9a7d75604ecd304094a602f3f7e45.svg";
export { ForwardRef as ReactComponent };